module.exports = __webpack_public_path__ + "static/img/104902.ab299e5e.png";